var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutBanner"},[_c('img',{attrs:{"src":_vm.bannerImg,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"info aboutBanner-Text whiteIndexTitle"},[_c('div',{staticClass:"indexTitle"},[_c('p',{staticClass:"flexItems"},[_c('span'),_vm._v(_vm._s(_vm.cnName))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.enName))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c898fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_banner.vue
// module id = null
// module chunks = 